import styles from "./RandomFact.module.scss"
import Image from "next/image"

import { useTranslation } from "next-i18next"

const RandomFact = ({ num = 0 } = {}) => {
  const { t } = useTranslation("common")

  const facts = {
    1: {
      title: t("SESSION_RANDOM_FACT_TITLE_1"),
      source: t("SESSION_RANDOM_FACT_SOURCE_1"),
    },
    2: {
      title: t("SESSION_RANDOM_FACT_TITLE_2"),
      source: t("SESSION_RANDOM_FACT_SOURCE_2"),
    },
    3: {
      title: t("SESSION_RANDOM_FACT_TITLE_3"),
      source: t("SESSION_RANDOM_FACT_SOURCE_3"),
      image: "/assets/regolao.webp",
    },
  }

  const { title, source, image = "" } = facts[num]

  return (
    <div className={styles.wrapper}>
      {image && <Image width={100} height={58} src={image} alt="" />}
      <div>
        <h3>{title}</h3>
        <span>{source}</span>
      </div>
    </div>
  )
}

export default RandomFact
